import React from "react";
import Header from "../../Components/Header";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import pdf from "../../asset/images/pdf-img.svg";
import axios from "axios";
import { partner_Api } from "../../Configuration/Partner_URL";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { useState } from "react";
import { copyText, decryptData } from "../../CommonMethhods/CommonMethods";
import linkdinImg from "../../asset/images/linkdinIcon.svg";

function ReferralLink() {
  const storeToken = localStorage.getItem("ssoToken");
  const partnerMobileNo = localStorage.getItem("partnerMobileNo");
  const partnerFlag = localStorage.getItem("partnerFlag");
  const partnerSsoToken = localStorage.getItem("partnerSsoToken");
  const PartnerMobile = localStorage.getItem("PartnerMobile");
  const [referalData, setReferalData] = useState("");
  const [referalVal, setReferalVal] = useState("");
  const [referalData1, setReferalData1] = useState("");
  const [partnerId, setPartnerId] = useState("");

  if (storeToken == null) {
    window.location.replace("/");
  }

  const getPartnerId = async () => {
    try {
      const getStatus = await axios.get(
        `${partner_Api.GET_PID_DETAILS}?mobile=${
          partnerFlag == "true" ? partnerMobileNo : PartnerMobile
        }`,

        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${
              partnerFlag == "true" ? partnerSsoToken : storeToken
            }`,
          },
        }
      );

      const res = decryptData(getStatus?.data);
      let decryptedResp = JSON.parse(res);
      const partnerId = decryptedResp?.data?.info?.partnerCode;
      if (decryptedResp?.status === 0) {
        setPartnerId(decryptedResp?.data?.info);
      } else {
        toast.error(decryptedResp?.message);
      }
      localStorage.setItem("partnerId", partnerId);
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }
  };

  useEffect(() => {
    getPartnerId();
  }, []);

  const getReferalLinkData = async () => {
    try {
      const getStatus = await axios.get(`${partner_Api.GET_REFERAL_LINK}`, {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${
            partnerFlag == "true" ? partnerSsoToken : storeToken
          }`,
        },
      });

      const res = decryptData(getStatus?.data);
      let decryptRes = JSON.parse(res);
      if (decryptRes?.status === 0) {
        setReferalVal(decryptRes?.data?.info[0]);
        setReferalData(decryptRes?.data?.info[1]);
        setReferalData1(decryptRes?.data?.info[2]);
      } else {
        toast.error(decryptRes?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }
  };

  useEffect(() => {
    getReferalLinkData();
  }, []);

  return (
    <>
      <Header portal={"TELECALLER"} />
      <SingleSignOnSideBar />
      <main id="main-content">
        <div className="partner-refer-wrapper">
          <ul className="partner-refer-cards">
            <li className="card-box bottom-25">
              {console.log(referalVal?.pack, "referalVal")}
              <h3 className="referal-title">
                {referalVal?.pack !== null ? referalVal?.pack : "-"}
              </h3>

              <div className="partner-refer-card-content row">
                <div className="card-content-left col-md-7">
                  <ul className="referral-info">
                    <li className="refer-desc">
                      Equity Delivery
                      <span>
                        {referalVal?.pan !== null ? referalVal?.pan : "-"}
                      </span>
                    </li>
                    <li className="refer-desc">
                      Intraday & Future & Options{" "}
                      <span>
                        {referalVal?.ifo !== null ? (
                          <>₹ {referalVal?.ifo} per Order</>
                        ) : (
                          "-"
                        )}
                      </span>
                    </li>
                  </ul>
                  <ul className="referral-info">
                    <li className="refer-desc">Free Demat Account</li>
                    <li className="refer-desc">
                      <span className="free-durat">Free 1st Year,</span>2nd year Onwards ₹431 (Inclusive of GST)
                    </li>
                  </ul>
                </div>
                <div className="col-md-1 pdf-img-wrapper">
                  <img src={pdf} alt="pdf" className="pdf-img" />
                </div>
                <div className="card-content-right col-md-4">
                  <div className="card-content-right-link">
                    <div className="partner-link" id="modifyreq">
                      https://ekyc.bajajfinservsecurities.in/?utm_source=Partner&utm_medium=Partner&utm_campaign=
                      {partnerId?.partnerCode}
                    </div>
                    <span
                      className="icon-copy"
                      onClick={(e) => copyText(e, "#modifyreq", "modifytest")}
                    ></span>

                    {/* <img src={copy} alt="copy"/> */}
                    <span id="modifytest" className="copy-txt">
                      Copied
                    </span>
                  </div>
                  <ul className="refer-social-icons">
                    <a
                      href={`https://www.facebook.com/sharer/sharer.php?u=https://ekyc.bajajfinservsecurities.in/?utm_source=Partner%26utm_medium=facebook%26utm_campaign=${partnerId?.partnerCode}&amp;quote=Open a BAJAJ BROKING account and start investing today!`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fab fa-facebook-square"></i>
                      <li>
                        <span className="icon-facebook"></span>
                      </li>
                    </a>
                    <a
                      href={`
https://twitter.com/intent/tweet?text=Open
a BAJAJ BROKING account and start investing today&amp;url=
https://ekyc.bajajfinservsecurities.in/?utm_source=Partner&utm_medium=twitter&utm_campaign=${partnerId?.partnerCode}&amp;related=`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fab fa-tumblr-square"></i>
                      <li>
                        <span className="icon-twitter"></span>
                      </li>
                    </a>
                    <a
                      href={`https://api.whatsapp.com/send?text=Open
a BAJAJ BROKING account and start investing today!
https://ekyc.bajajfinservsecurities.in/?utm_source=Partner%26utm_medium=whatsapp%26utm_campaign=${partnerId?.partnerCode}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fab fa-whatsapp-square"></i>
                      <li>
                        <span className="icon-whatsapp"></span>
                      </li>
                    </a>
                    <a
                      href={`https://www.linkedin.com/shareArticle?mini=true&amp;url=https://ekyc.bajajfinservsecurities.in/?utm_source%3DPartner%26utm_medium%3Dlinkedin%26utm_campaign%3D${partnerId?.partnerCode}&amp;title=&amp;summary=&amp;source=`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <li>
                        <img
                          className="linkdin-icon"
                          src={linkdinImg}
                          alt="Pending"
                        />
                      </li>
                    </a>
                  </ul>
                </div>
              </div>
            </li>
            <li className="card-box light-blue bottom-25">
              <h3 className="referal-title blue-txt">
                {referalData?.pack !== null ? referalData?.pack : "-"}
              </h3>

              <div className="partner-refer-card-content row">
                <div className="card-content-left col-md-7">
                  <ul className="referral-info">
                    <li className="refer-desc">
                      Equity Delivery
                      <span>
                        {referalData?.pan !== null ? referalData?.pan : "-"}
                      </span>
                    </li>
                    <li className="refer-desc">
                      Intraday & Future & Options{" "}
                      <span>
                        {referalData?.ifo !== null ? (
                          <>₹ {referalData?.ifo} per Order</>
                        ) : (
                          "-"
                        )}
                      </span>
                    </li>
                  </ul>
                  <ul className="referral-info">
                    <li className="refer-desc">Free Demat Account</li>
                    <li className="refer-desc">
                      Account Opening Charges ₹199 (Inclusive of GST)
                    </li>
                  </ul>
                </div>
                <div className="col-md-1 pdf-img-wrapper">
                  <img src={pdf} alt="pdf" className="pdf-img" />
                </div>
                <div className="card-content-right col-md-4">
                  <div className="card-content-right-link">
                    <div className="partner-link" id="modifyreq1">
                      https://free-demat.bajajfinservsecurities.in/?utm_source=Freedom_Plus&referal_code=
                      {partnerId?.partnerCode}
                    </div>
                    <span
                      className="icon-copy"
                      onClick={(e) => copyText(e, "#modifyreq1", "modifytest1")}
                    ></span>
                    {/* <img src={copy} alt="copy"/> */}
                    <span id="modifytest1" className="copy-txt">
                      Copied
                    </span>
                  </div>
                  <ul className="refer-social-icons">
                    <a
                      href={`https://www.facebook.com/sharer/sharer.php?u=https://free-demat.bajajfinservsecurities.in/?utm_source=Freedom_Plus&referal_code=${partnerId?.partnerCode}&amp;quote=Open a BAJAJ BROKING account and start investing today!`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fab fa-facebook-square"></i>
                      <li>
                        <span className="icon-facebook"></span>
                      </li>
                    </a>
                    <a
                      href={`
https://twitter.com/intent/tweet?text=Open
a BAJAJ BROKING account and start investing today&amp;url=
https://free-demat.bajajfinservsecurities.in/?utm_source=Freedom_Plus&referal_code=${partnerId?.partnerCode}&amp;related=`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fab fa-tumblr-square"></i>
                      <li>
                        <span className="icon-twitter"></span>
                      </li>
                    </a>
                    <a
                      href={`https://api.whatsapp.com/send?text=Open
a BAJAJ BROKING account and start investing today!
https://free-demat.bajajfinservsecurities.in/?utm_source=Freedom_Plus&referal_code=${partnerId?.partnerCode}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fab fa-whatsapp-square"></i>
                      <li>
                        <span className="icon-whatsapp"></span>
                      </li>
                    </a>
                    <a
                      href={`https://www.linkedin.com/shareArticle?mini=true&amp;url=https://free-demat.bajajfinservsecurities.in/?utm_source=Freedom_Plus&referal_code=${partnerId?.partnerCode}&amp;title=&amp;summary=&amp;source=`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <li>
                        <img
                          className="linkdin-icon"
                          src={linkdinImg}
                          alt="Pending"
                        />
                      </li>
                    </a>
                  </ul>
                </div>
              </div>
            </li>
            <li className="card-box light-yellow">
              <h3 className="referal-title yellow-txt">
                {referalData1?.pack !== null ? referalData1?.pack : "-"}
              </h3>

              <div className="partner-refer-card-content row">
                <div className="card-content-left col-md-7">
                  <ul className="referral-info referral-info-yellowcard">
                    <li className="refer-desc">
                      Delivery
                      <span>
                        {referalData1?.delivery !== null ? (
                          <>{referalData1?.delivery?.toFixed(2)}%</>
                        ) : (
                          "-"
                        )}
                      </span>
                    </li>
                    <li className="refer-desc">
                      Intraday{" "}
                      <span>
                        {referalData1?.intraday !== null
                          ? referalData1?.intraday + "%"
                          : "-"}
                      </span>
                    </li>
                    <li className="refer-desc">
                      Futures{" "}
                      <span>
                        {referalData1?.future !== null
                          ? referalData1?.future + "%"
                          : "-"}
                      </span>
                    </li>
                    <li className="refer-desc">
                      Options{" "}
                      <span>
                        {referalData1?.options !== null ? (
                          <>₹{referalData1?.options} Per Lot</>
                        ) : (
                          "-"
                        )}
                      </span>
                    </li>
                  </ul>
                  <ul className="referral-info">
                    <li className="refer-desc">
                      <strong>Standard Rates</strong>
                    </li>
                  </ul>
                </div>
                <div className="col-md-1 pdf-img-wrapper">
                  <img src={pdf} alt="pdf" className="pdf-img" />
                </div>
                <div className="card-content-right col-md-4">
                  <div className="card-content-right-link">
                    <div className="partner-link" id="modifyreq2">
                    https://hniekyc.bajajfinservsecurities.in/?utm_source=Partner&utm_medium=Partner&utm_campaign={partnerId?.partnerCode}
                    </div>
                    <span
                      className="icon-copy"
                      onClick={(e) => copyText(e, "#modifyreq2", "modifytest2")}
                    ></span>
                    {/* <img src={copy} alt="copy" /> */}
                    <span id="modifytest2" className="copy-txt">
                      Copied
                    </span>
                  </div>
                  <ul className="refer-social-icons">
                    <a
                      href={`https://www.facebook.com/sharer/sharer.php?u=https://hniekyc.bajajfinservsecurities.in/?utm_source=Partner&utm_medium=Partner&utm_campaign=${partnerId?.partnerCode}&amp;quote=Open a BAJAJ BROKING account and start investing today!`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fab fa-facebook-square"></i>
                      <li>
                        <span className="icon-facebook"></span>
                      </li>
                    </a>
                    <a
                      href={`
https://twitter.com/intent/tweet?text=Open
a BAJAJ BROKING account and start investing today&amp;url=
https://hniekyc.bajajfinservsecurities.in/?utm_source=Partner&utm_medium=Partner&utm_campaign=${partnerId?.partnerCode}&amp;related=`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fab fa-tumblr-square"></i>
                      <li>
                        <span className="icon-twitter"></span>
                      </li>
                    </a>
                    <a
                      href={`https://api.whatsapp.com/send?text=Open
a BAJAJ BROKING account and start investing today!
https://hniekyc.bajajfinservsecurities.in/?utm_source=Partner&utm_medium=Partner&utm_campaign=${partnerId?.partnerCode}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fab fa-whatsapp-square"></i>
                      <li>
                        <span className="icon-whatsapp"></span>
                      </li>
                    </a>
                    <a
                      href={`https://www.linkedin.com/shareArticle?mini=true&amp;url=https://hniekyc.bajajfinservsecurities.in/?utm_source=Partner&utm_medium=Partner&utm_campaign=${partnerId?.partnerCode}&amp;title=&amp;summary=&amp;source=`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <li>
                        <img
                          className="linkdin-icon"
                          src={linkdinImg}
                          alt="Pending"
                        />
                      </li>
                    </a>
                  </ul>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </main>
    </>
  );
}

export default ReferralLink;
